import React, { FC, useLayoutEffect, Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import loadable from '@loadable/component';
import ModalStore, { closeModal } from 'lib/stores/modalStore';
import ConfigStore from 'lib/stores/configStore';
import Modal from 'lib/components/Modal';
import ResidentGenerate from 'lib/components/generate/ResidentGenerate';

const ResidentForm: FC<ResidentFormProps> = loadable(() => import('lib/components/Forms/Host/Resident'));

interface ResidentModalProps {
  covidStatuses: Array<string>
}

const ResidentModal: FC<ResidentModalProps> = ({ covidStatuses }) => {
  const { open, data: { resident } } = ModalStore.useState(state => state.residentModal);
  const editingResident = Object.keys(resident).length > 0;

  const closeResidentModal = () => (
    ModalStore.update(state => closeModal(state, 'resident', { resident: {} }))
  );

  useLayoutEffect(() => {
    if (!open) return;

    ConfigStore.update(s => { s.currentPage = 'resident'; });
  }, [open]);

  return (
    <Modal
      title={editingResident ? 'Edit Resident' : 'Add Resident'}
      onClose={closeResidentModal}
      acceptMessage="Submit"
      open={open}
      id="residentModal"
    >
      <ResidentGenerate />
      <ErrorBoundary fallback={<div>Error loading form</div>}>
        <Suspense fallback={<div>Loading form...</div>}>
          <ResidentForm
            existingResident={resident}
            onAfterSubmit={closeResidentModal}
            covidStatuses={covidStatuses}
          />
        </Suspense>
      </ErrorBoundary>
    </Modal>
  );
};

export default ResidentModal;
